var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hint cursor-pointer",class:[_vm.showHint ? 'show' : ''],on:{"click":function($event){return _vm.toggleShowHint()}}},[_vm._v("\n        ?\n        "),_c('div',{staticClass:"hint-text cursor-text",domProps:{"innerHTML":_vm._s(_vm.hint)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }